import {Checkbox, FormControlLabel, FormGroup, useTheme} from "@mui/material";
import React from "react";
import {IHeaderGroupParams} from "ag-grid-community";

type IProps = IHeaderGroupParams & {
    disabled: boolean | undefined | null;
    defaultValue: boolean;
    field: string;
    label: string;
    width: number;
    onChange?: (event: any) => void;
}

const CheckboxRenderer = ({disabled, defaultValue, field, label, width, onChange, ...params}: IProps) => {
    // Use Theme
    const theme = useTheme();

    const checkedHandler = (event: any) => {
        let checked = event.target.checked;
        const rentalPeriodColumn = field.split(".")[0];
        const currentCheckName = field.split(".")[1];

        params.api.forEachNodeAfterFilterAndSort((node: any) => {
            node.setData({
                ...node.data,
                [rentalPeriodColumn]: {
                    ...node.data[rentalPeriodColumn],
                    [currentCheckName]: checked,
                    extraKm: currentCheckName === "unlimitedKm" && checked ? '' : node.data[rentalPeriodColumn].extraKm
                }
            });
        });
    };

    return (
        <FormGroup sx={{width: width - 18}}>
            <FormControlLabel label={label}
                              sx={{
                                  ".MuiFormControlLabel-label": {
                                      fontSize: "12px !important",
                                      marginLeft: "-5px"
                                  }
                              }}
                              control={<Checkbox onClick={checkedHandler}
                                                 sx={{
                                                     ".Mui-checked": {
                                                         color: theme.palette.accent.main
                                                     }
                                                 }}
                                                 disabled={Boolean(disabled)}
                                                 defaultChecked={defaultValue}
                                                 onChange={onChange}
                              />}
            />
        </FormGroup>
    );
};

export default CheckboxRenderer;